export * from './userTypes';
export * from './bookTypes';
export * from './scheduleTypes';
export * from './systemTypes';
export * from './questionType';
export * from './unitTypes';
export * from './koreanType';
export * from './collectionNames';

export const MAIN_COLOR = '#5e17eb';
export const CompanyName = '정성우학원';
export const CompanySlogan = '"신뢰를 더해가는 성장의 공식"\n정성우학원이 만들어갑니다.';
export const CompanyOwner = '정성우';
export const CompanyBusinessNumber = '138-82-00191';
export const CompanyAddress = '경기도 수원시 영통구 효원로 393, 702호 전면(매탄동, 밀레니엄프라자)';
export const CompanyPhone = '031-217-3412';
export const CompanyEmail = 'jswstudy@gmail.com';
export const CompanyNaverBlogUrl = 'https://blog.naver.com/math_science_3412';
export const CompanyInstagramUrl = 'https://www.instagram.com/jungsungwoo_academy/';
export const CompanyYoutubeUrl = 'https://www.youtube.com/@jswacademy_official';
export const CompanyKakaoUrl = 'https://pf.kakao.com/_pWwWj';

// Constants
export const SUCCESS_TYPES = ['성적', '향상', '등급', '등수', '고입', '대입'] as const;
export const SUBJECT_TYPES = ['국어', '영어', '수학', '과학'] as const;
export const GRADE_TYPES = ['초등', '초등1', '초등2', '초등3', '초등4', '초등5', '초등6',
  '중등', '중등1', '중등2', '중등3',
  '고등', '고등1', '고등2', '고등3'
] as const;
export const TERM_TYPES = ['1학기 중간', '1학기 기말', '2학기 중간', '2학기 기말'] as const;
export const BOOK_TYPES = ['문제집', '기본서', '모의고사', '단어장', '부교재'] as const;
export const PUBLISHERS = ['자체교재', '디딤돌', '비상교육', '신사고', '천재교육', 'EBS', '수경출판사', '마더텅', '블랙라벨'] as const;

export type SuccessType = typeof SUCCESS_TYPES[number];
export type SubjectType = typeof SUBJECT_TYPES[number];
export type GradeType = typeof GRADE_TYPES[number];
export type TermType = typeof TERM_TYPES[number];


export type BookType = typeof BOOK_TYPES[number];
export type PublisherType = typeof PUBLISHERS[number];
export const UNIVERSITIES = [
  { name: '서울대학교', logoUrl: '' },
  { name: '연세대학교', logoUrl: '' },
  { name: '고려대학교', logoUrl: '' },
  { name: '서강대학교', logoUrl: '' },
  { name: '성균관대학교', logoUrl: '' },
  { name: '한양대학교', logoUrl: '' },
  { name: '이화여자대학교', logoUrl: '' },
  { name: '중앙대학교', logoUrl: '' },
  { name: '경희대학교', logoUrl: '' },
  { name: '한국외국어대학교', logoUrl: '' },
  { name: '서울시립대학교', logoUrl: '' },
  { name: '카이스트', logoUrl: '' },
  { name: '포항공과대학교', logoUrl: '' },
  { name: '유니스트', logoUrl: '' }
] as const;

export const EXAM_TYPES = ['중간고사', '기말고사', '모의고사', '수능', '학력평가', '단원평가'] as const;
export const NOTICE_CATEGORIES = ['학원공지', '국어과', '수학과', '과학과', '영어과'] as const;
